import { useEffect } from 'react';
import { useToast } from '../context/ToastContext';
import { registerConflictHandler } from '../utils/optimisticSave';

// Toast Lot 3 — pont entre optimisticSave (utility module-level, hors React) et
// le toast central. Monte une fois, enregistre le handler appele sur conflit 409.
// optimisticSave pre-resout le message i18n, donc ce bridge n'a pas besoin de t :
// il recoit la STRING traduite et la pousse via showError. Ne rend rien.

export default function ConflictToastBridge() {
  const { showError } = useToast();

  useEffect(() => {
    registerConflictHandler((message) => showError(message));
  }, [showError]);

  return null;
}
